__turbopack_context__.v({
  "price": "price-module-scss-module__trXRLG__price",
  "price__actual": "price-module-scss-module__trXRLG__price__actual",
  "price__old": "price-module-scss-module__trXRLG__price__old",
  "regular": "price-module-scss-module__trXRLG__regular",
  "unavailable": "price-module-scss-module__trXRLG__unavailable",
  "wide": "price-module-scss-module__trXRLG__wide",
  "wideOnMobile": "price-module-scss-module__trXRLG__wideOnMobile",
});
